import { Component } from "react";
import { PieChart, Pie, Cell, Tooltip, Legend, BarChart, Bar, CartesianGrid, XAxis, YAxis, ResponsiveContainer } from 'recharts';

const COLORS = [
    "#FF6384", "#4BC0C0", "#FFCE56", "#9966FF", "#FF9F40",
    "#64B5F6", "#E57373", "#81C784", "#FFD54F", "#BA68C8",
    "#4DB6AC", "#F06292", "#7986CB", "#AED581", "#FF9F40",
    "#4FC3F7", "#FFF176", "#A1887F", "#90A4AE", "#DCE775",
];

const COLOR_BLIND_FRIENDLY = [
    "#E69F00", "#56B4E9", "#009E73", "#F0E442", "#0072B2",
    "#D55E00", "#CC79A7", "#999999", "#66C2A5", "#FC8D62",
    "#8DA0CB", "#E78AC3", "#A6D854", "#FFD92F", "#E5C494",
    "#B3B3B3", "#1B9E77", "#D95F02", "#7570B3", "#E7298A",
];

export class AnalyticItem extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    componentDidMount() {
        this.populateGraphData()
    }

    componentDidUpdate(prevProps, _prevState) {
        if (prevProps !== this.props) {
            this.populateGraphData()
        }
    }

    populateGraphData() {
        this.setState({
            ...this.state.props,
            data: this.props.analytics.distribution.map((item, idx) => ({
                name: item.answer,
                value: item.count,
                fill: this.props.colorblindSetting
                    ? COLOR_BLIND_FRIENDLY[idx % COLOR_BLIND_FRIENDLY.length]
                    : COLORS[idx % COLORS.length],
            })),
        })
    }

    render() {
        return (
            <ResponsiveContainer width="100%" height={400}>
                {this.state.data && (this.props.analytics.questionType == 1 ?
                    <PieChart>
                        <Pie
                            data={this.state.data}
                            cx="50%"
                            cy="50%"
                            labelLine={false}
                            // outerRadius={150}
                            dataKey="value"
                        >
                            {this.state.data && this.state.data.map((entry, idx) => (
                                <Cell key={`cell-${idx}`} fill={entry.fill}/>
                            ))}
                        </Pie>
                        <Tooltip wrapperStyle={{zIndex: 10}} />
                        <Legend />
                    </PieChart>
                    :
                    <BarChart data={this.state.data}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis />
                        <Bar dataKey="value">
                            {this.state.data && this.state.data.map((entry, idx) => (
                                <Cell key={`cell-${idx}`} fill={entry.fill}/>
                            ))}
                        </Bar>
                        <Tooltip wrapperStyle={{zIndex: 10}} />
                    </BarChart>
                )}
            </ResponsiveContainer>
        )
    }
}